import { render, staticRenderFns } from "./Backup.vue?vue&type=template&id=25dc4eb7&scoped=true&"
import script from "./Backup.vue?vue&type=script&lang=js&"
export * from "./Backup.vue?vue&type=script&lang=js&"
import style0 from "./Backup.vue?vue&type=style&index=0&id=25dc4eb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc4eb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VForm,VRow,VSelect,VSheet,VSkeletonLoader,VSwitch})
